import { Head, useForm } from '@inertiajs/react'
import { SubmitEvent } from 'react'
import { EventFormData } from '@/types/shared'
import { ManagerEventsNewProps } from '@/types/manager_events'
import EventForm from './_form'

export default function NewEvent({ tracks, seasons, paths, errors }: ManagerEventsNewProps) {
  const defaultTrackId = tracks.length === 1 ? tracks[0].id.toString() : ''

  const { data, setData, post, processing } = useForm<EventFormData>({
    event: {
      name: '',
      slug: '',
      date: '',
      track_id: defaultTrackId,
      applications_open_at: '',
      applications_close_at: '',
      publish_at: '',
      description: '',
      price: '',
      schedule: '',
      notes: '',
      parking_override: '',
      pit_access_override: '',
      instagram_hashtag: '',
      social_urls: '',
      accepts_drivers: false,
      accepts_teams: false,
      accepts_staff: false,
      accepts_media: false,
      // Null, not false — a new event inherits the venue's answer until its
      // manager says otherwise.
      media_auto_approval_override: null,
      media_auto_approval_limit_override: null,
      // Null follows the rule: allowed for a type unless that type applies.
      driver_self_reports_override: null,
      media_self_reports_override: null,
      poster: null,
      remove_poster: false,
      season_id: '',
    }
  })

  const handleSubmit = (e: SubmitEvent) => {
    e.preventDefault()
    post(paths.create)
  }

  return (
    <div className="flex">
      <Head title="New Event" />
      <div className="grow">
        <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
          <EventForm
            data={data}
            setData={setData}
            onSubmit={handleSubmit}
            processing={processing}
            errors={errors}
            tracks={tracks}
            seasons={seasons}
            title="New Event"
            submitLabel="Create Event"
          />
        </div>
      </div>
    </div>
  )
}
